t = require('app/scripts/views/internal/teacup-with-helpers')('board_closed')

module.exports = t.renderable ({
  name,
  deleting,
  canReopen,
  canDelete,
  isDesktop,
  isAtOrOverLimit,
  orgName,
  billingUrl,
}) ->
  t.div '.big-message.quiet.closed-board', ->
    t.h1 ->
      t.format 'name-is-closed', { name }

    if deleting
      t.format 'deleting'
    else
      if isAtOrOverLimit
        t.p '.messaging', ->
          if isDesktop || !orgName || !billingUrl
            t.format 'cannot-reopen-board-limit-reached-desktop'
          else
            t.format 'cannot-reopen-board-limit-reached', { orgName, billingUrl }

      else if !canReopen && !canDelete
        t.p '.messaging', ->
          t.format 'you-re-a-member-of-this-board-but-only-board-admins-are-able-to-re-open-it'

      if canReopen && !isAtOrOverLimit
        t.p ->
          t.a '.js-reopen', { href: '#' }, ->
            t.format 'reopen'

      if canDelete
        t.p '.delete-container', ->
          t.a '.quiet.js-delete', { href: '#' }, ->
            t.format 'permanently-delete-board'
